import { useLogin } from '../../hooks/auth/useLogin.js';

export default function Logout() {
    const { logout } = useLogin();

    return (
        <button className="dropdown-item" onClick={logout}>
            Cerrar sesión
        </button>
    );
}